import getTextualLabels from "./getTextualLabels";

const textualValues = {
  5: [
    { value: 1, label: "very_hard" },
    { value: 2, label: "hard" },
    { value: 3, label: "neutral" },
    { value: 4, label: "easy" },
    { value: 5, label: "very_easy" }
  ],
  7: [
    { value: 1, label: "extremely_hard" },
    { value: 2, label: "very_hard" },
    { value: 3, label: "hard" },
    { value: 4, label: "neutral" },
    { value: 5, label: "easy" },
    { value: 6, label: "very_easy" },
    { value: 7, label: "extremely_easy" }
  ]
};

/**
 * Get scale array based on textual questions
 * @param {The max scale to know what labels to use} maxScale
 */
export default function getTextualScale(maxScale, language) {
  let textualScale = [...textualValues[maxScale]];

  return getTextualLabels(textualScale, language);
}
